import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IOrderReviewsResponse } from '../../types/api/orderReviewsApi';
import { getOrderReviewDetailService, getOrderReviewsDataService } from '../../api/orderReviewsApi';
import { OrderReviewsState } from '../../types/features/orderReviewsSlice';
import { ITableRequestData } from '../../types/common';



export const getOrderReviewsData = createAsyncThunk<IOrderReviewsResponse, ITableRequestData>(
    'orderReviews/getOrderReviewsData',
    async ({ limit, page }) => {
        const response = await getOrderReviewsDataService({ limit, page });
        return response.data;
    }
);

export const getOrderReviewDetailData = createAsyncThunk<IOrderReviewsResponse, { id: string }>(
    'orderReviews/getOrderReviewDetail',
    async ({ id }) => {
        const response = await getOrderReviewDetailService({ id });
        return response.data;
    }
);


const OrderReviewsSlice = createSlice({
    name: 'OrderReviews',
    initialState: {
        orderReviewLoader: false,
        status: false,
        msg: '',
        data: null,
        total: 0,
        detail: null
    } as OrderReviewsState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrderReviewsData.pending, (state) => {
                state.orderReviewLoader = true;
            })
            .addCase(getOrderReviewsData.fulfilled, (state, action: PayloadAction<IOrderReviewsResponse>) => {
                state.data = action.payload?.data?.order_reviews || [];
                state.total = action.payload?.data?.total || 0;
                state.msg = action.payload.message;
                state.status = true;
                state.orderReviewLoader = false;
            })
            .addCase(getOrderReviewsData.rejected, (state, action) => {
                state.orderReviewLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(getOrderReviewDetailData.pending, (state) => {
                state.orderReviewLoader = true;
            })
            .addCase(getOrderReviewDetailData.fulfilled, (state, action: PayloadAction<IOrderReviewsResponse>) => {
                state.detail = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.orderReviewLoader = false;
            })
            .addCase(getOrderReviewDetailData.rejected, (state, action) => {
                state.orderReviewLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
    }
});

export default OrderReviewsSlice.reducer;
